/* src/modules/tutor/cards/TutorCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';
import { get, isEmpty } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import {
  Card,
  CardActions,
  Collapse,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from '@material-ui/core';
import {
  BorderColor,
  EventNote,
  ExpandMore,
  Folder,
  PlaylistAddCheck,
} from '@material-ui/icons';

import {
  ConfirmationPopup,
  DisabledPage,
  SimpleTable,
  HeaderTable,
  TabBar,
} from '../../../../app/components';
import {
  ReviewsTable,
  UserContent,
  UserHeader,
  Notes,
} from '../../../../app/components/user';

import SettingsCard from '../SettingsCard';
import LessonCard from '../../../lessons/cards/LessonCard';
import ViewSignatureCard from '../ViewSignatureCard';
import ViewDocumentsCard from '../ViewDocumentsCard';
import styles from './styles';

import {
  getSelected,
  fetchTutorState,
  getLessons,
  getPaymentInfo,
  getReviewsList,
  getReviewsData,
  getAnalyticsData,
  getAverages,
  getPaymentErrors,
  getLessonInfo,
  getNotesList,
  getFeedbackList,
} from '../../selectors';

import {
  setReviewVisibility,
  fetchTutor,
  addNote,
  removeNote,
  removeTutor,
  clearSelectedTutor,
} from '../../actions';
import { fetchUserLesson } from '../../../lessons/actions';
import { lessonSetInfo } from '../../../lessons/cards/LessonCard/actions';
import { loadTexts } from '../../../../config/texts';

// const transactionHistory = [
//   { title: formatDate(new Date()), value: 'Total: 20.00 CAD' },
//   { title: formatDate(new Date()), value: 'Total: 20.00 CAD' },
//   { title: formatDate(new Date()), value: 'Total: 20.00 CAD' },
//   { title: formatDate(new Date()), value: 'Total: 20.00 CAD' },
// ];
const TEXT_KEY = 'tutors';

class TutorCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
      value: 0,
      expandedReview: false,
      openLessonCard: false,
      openSettingsCard: false,
      openNotes: false,
      openSignature: false,
      openDocuments: false,
      anchorEl: null,
      openDeleteConfirmation: false,
      texts: loadTexts(TEXT_KEY, props.locale)
    };

    this._onToggleExpand = this._onToggleExpand.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this._toggleLessonCard = this._toggleLessonCard.bind(this);
    this._toggleSettingsCard = this._toggleSettingsCard.bind(this);
    this._toggleNotes = this._toggleNotes.bind(this);
    this._onCloseSignature = this._onCloseSignature.bind(this);
    this._onClickSignature = this._onClickSignature.bind(this);
    this._onCloseDocuments = this._onCloseDocuments.bind(this);
    this._onClickDocuments = this._onClickDocuments.bind(this);
    this._onClickVisibility = this._onClickVisibility.bind(this);
    this._onOpenUserMenu = this._onOpenUserMenu.bind(this);
    this._onCloseUserMenu = this._onCloseUserMenu.bind(this);
    this._onDeleteTutor = this._onDeleteTutor.bind(this);
    this._onCloseDeleteConfirmation = this._onCloseDeleteConfirmation.bind(this);
    this._onOpenDeleteConfirmation = this._onOpenDeleteConfirmation.bind(this);

    this._onAddNote = this._onAddNote.bind(this);
    this._onRemoveNote = this._onRemoveNote.bind(this);

    this._onRefundStudent = this._onRefundStudent.bind(this);
  }

  async componentDidMount() {
    const { tasks } = this.props;
    if (isEmpty(tasks)) return;
    for (let task of tasks) {
      switch (task.action) {
        case 'fetch':
          await this.props.fetchTutor({ tutor: task.payload });
          break;
        case 'tab':
          await new Promise(resolve => {
            let value = 0;
            switch(task.payload) {
              case 'lessons': value = 0; break;
              case 'analytics': value = 1; break;
              case 'reviews': value = 2; break;
              case 'feedback': value = 3; break;
              case 'payment': value = 4; break;
              default: value = 0;
            }
            this.setState({ value }, () => { resolve() });
          });
          break;
        case 'expand_review':
          await new Promise(resolve => {
            this.setState({ expandedReview: task.payload }, () => {
              resolve();
            });
          });
          break;
        default:
          break;
      }
    }
  }

  _onToggleExpand() {
    this.setState({ expanded: !this.state.expanded });
  }

  _handleChange(event, value) {
    this.setState({ value });
  }

  _toggleLessonCard(type) {
    return async data => {
      if (type) {
        await this.props.fetchUserLesson({ lesson: data._id });
        this.props.lessonSetInfo(this.props.lessonInfo);
      }
      this.setState({ openLessonCard: type });
    };
  }

  _toggleSettingsCard(type) {
    return () => this.setState({ openSettingsCard: type });
  }

  _toggleNotes(type) {
    return () => this.setState({ openNotes: type });
  }

  _onCloseSignature() {
    this.setState({ openSignature: false });
  }

  _onClickSignature() {
    this.setState({ openSignature: true });
  }

  _onCloseDocuments() {
    this.setState({ openDocuments: false });
  }

  _onClickDocuments() {
    this.setState({ openDocuments: true });
  }

  _onOpenDeleteConfirmation() {
    this.setState({ openDeleteConfirmation: true, anchorEl: null });
  }

  _onCloseDeleteConfirmation() {
    this.setState({ openDeleteConfirmation: false });
  }

  _onRefundStudent() {
    this.props.fetchTutor({ tutor: this.props.tutor._id });
  }

  async _onClickVisibility(review) {
    await this.props.setReviewVisibility({ review: review._id, visible: !review.visible });
    this.props.fetchTutor({ tutor: this.props.tutor._id });
  }

  async _onAddNote(text) {
    await this.props.addNote({ noteInput: {
      _user: this.props.tutor._id,
      body: text,
    } });

    this.props.fetchTutor({ tutor: this.props.tutor._id });
  }

  async _onRemoveNote(note) {
    await this.props.removeNote({
      note: note._id,
    });

    this.props.fetchTutor({ tutor: this.props.tutor._id });
  }

  _onOpenUserMenu(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  _onCloseUserMenu() {
    this.setState({ anchorEl: null });
  }

  async _onDeleteTutor() {
    this.setState({ openDeleteConfirmation: false });
    await this.props.removeTutor({ tutor: this.props.tutor._id });
    this.props.fetchTutors();
    this.props.clearSelectedTutor();
  }

  renderExpandButton(classes, expanded) {
    const { texts: { button_text } } = this.state;
    return (
      <IconButton
        className={classNames(
          classes.expand,
          { [classes.expandOpen]: expanded }
        )}
        aria-expanded={expanded}
        aria-label={button_text.show_more}
        onClick={this._onToggleExpand}
      >
        <ExpandMore />
      </IconButton>
    );
  }

  render() {
    const {
      classes,
      tutor,
      lessons,
      paymentInfo,
      reviews,
      reviewsData,
      feedback,
      analyticsData,
      averageData,
      paymentErrors,
      notes,
    } = this.props;
    const {
      expanded,
      value,
      openLessonCard,
      openSettingsCard,
      openNotes,
      openSignature,
      openDocuments,
      anchorEl,
      openDeleteConfirmation,
      texts,
    } = this.state;
    return (
      <React.Fragment>
        <Card className={classes.card}>
          {!tutor.empty && (
            <React.Fragment>
              <UserHeader
                caption={tutor.available ? texts.header.online : texts.header.offline}
                onMoreActions={this._onOpenUserMenu}
                name={tutor.name}
                email={tutor.email}
                phone={tutor.phone}
                src={tutor.avatar}
              />
              <Menu
                id="tutor-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this._onCloseUserMenu}
              >
                <MenuItem onClick={this._onOpenDeleteConfirmation}>
                  <Typography color="secondary">
                    {texts.button_text.delete_tutor}
                  </Typography>
                </MenuItem>
              </Menu>
              <CardActions classes={{ root: classes.moreInfo }}>
                <Tooltip id="notes" title={texts.button_text.notes}>
                  <IconButton aria-label="Notes" onClick={this._toggleNotes(true)}>
                    <EventNote />
                  </IconButton>
                </Tooltip>
                {/* }<Tooltip id="message" title="Message">
                  <IconButton aria-label="Message"><Message /></IconButton>
                </Tooltip> */}
                <Tooltip id="documents" title={texts.button_text.view_document}>
                  <IconButton aria-label="Documents" onClick={this._onClickDocuments}>
                    <Folder />
                  </IconButton>
                </Tooltip>
                <Tooltip id="signature" title={texts.button_text.signature}>
                  <IconButton aria-label="Signature" onClick={this._onClickSignature}>
                    <BorderColor />
                  </IconButton>
                </Tooltip>
                <Tooltip id="checklist" title={texts.button_text.checklist}>
                  <IconButton
                    aria-label="Checklist"
                    color="primary"
                    onClick={this._toggleSettingsCard(true)}
                  >
                    <PlaylistAddCheck />
                  </IconButton>
                </Tooltip>
                {this.renderExpandButton(classes, expanded)}
              </CardActions>
              <Divider />
              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <UserContent
                  bio={tutor.bio}
                  education={tutor.education}
                  hearAboutUs={tutor.hearAboutUs}
                />
              </Collapse>
              <TabBar
                value={value}
                onChange={this._handleChange}
                labels={[
                  texts.labels.lessons,
                  texts.labels.analytics,
                  texts.labels.reviews,
                  texts.labels.feedback,
                  texts.labels.payment
                ]}
              />
              {value === 0 && (
                <HeaderTable
                  data={lessons}
                  hover
                  onRowClick={this._toggleLessonCard(true)}
                />
              )}
              {value === 1 && (
                <React.Fragment>
                  <SimpleTable data={analyticsData} gutterBottom />
                  <SimpleTable data={averageData} header={texts.header.average} />
                </React.Fragment>
              )}
              {value === 2 && (
                <React.Fragment>
                  <SimpleTable data={reviewsData} gutterBottom />
                  <ReviewsTable
                    data={reviews}
                    type="tutor"
                    onClickVisibility={this._onClickVisibility}
                    expanded={this.state.expandedReview}
                  />
                </React.Fragment>
              )}
              {value === 3 && (
                <ReviewsTable
                  data={feedback}
                  onClickVisibility={this._onClickVisibility}
                  expanded={this.state.expandedReview}
                  type="student"
                />
              )}
              {value === 4 && (
                <React.Fragment>
                  <SimpleTable data={paymentInfo} gutterBottom />
                  <SimpleTable
                    data={paymentErrors}
                    header={texts.header.error}
                    gutterBottom
                    hover
                  />
                  {/* <SimpleTable
                    data={transactionHistory}
                    header="Transaction History"
                    hover
                  /> */}
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </Card>
        <LessonCard
          open={openLessonCard}
          onClose={this._toggleLessonCard(false)}
          onRefundStudent={this._onRefundStudent}
        />
        <SettingsCard
          open={openSettingsCard}
          name={tutor.name}
          onClose={this._toggleSettingsCard(false)}
        />
        <Notes
          open={openNotes}
          onClose={this._toggleNotes(false)}
          onAdd={this._onAddNote}
          onRemove={this._onRemoveNote}
          notes={notes}
        />
        <ViewSignatureCard
          open={openSignature}
          onClose={this._onCloseSignature}
          tutorID={tutor._id}
        />
        <ViewDocumentsCard
          open={openDocuments}
          onClose={this._onCloseDocuments}
          tutorID={tutor._id}
        />
        <ConfirmationPopup
          open={openDeleteConfirmation}
          title={texts.pop_up.title}
          subtitle={texts.pop_up.subtitle}
          affirmativeButtonText={texts.pop_up.confirm}
          onClose={this._onCloseDeleteConfirmation}
          onSubmit={this._onDeleteTutor}
        />
      </React.Fragment>
    );
  }
}


TutorCard.propTypes = {
  classes: PropTypes.object.isRequired,
  tutor: PropTypes.object,
  lessons: PropTypes.array.isRequired,
  paymentInfo: PropTypes.array.isRequired,
  reviews: PropTypes.array.isRequired,
  feedback: PropTypes.array.isRequired,
  reviewsData: PropTypes.array.isRequired,
  analyticsData: PropTypes.array.isRequired,
  averageData: PropTypes.array.isRequired,
  paymentErrors: PropTypes.array.isRequired,
  notes: PropTypes.array.isRequired,
  fetchUserLesson: PropTypes.func.isRequired,
  lessonSetInfo: PropTypes.func.isRequired,
  fetchTutor: PropTypes.func.isRequired,
  setReviewVisibility: PropTypes.func.isRequired,
  addNote: PropTypes.func.isRequired,
  removeNote: PropTypes.func.isRequired,
  removeTutor: PropTypes.func.isRequired,
  fetchTutors: PropTypes.func.isRequired,
  clearSelectedTutor: PropTypes.func.isRequired,
  lessonInfo: PropTypes.object.isRequired,
};

TutorCard.defaultProps = {
  tutor: {},
};

const mapStateToProps = state => ({
  tutor: getSelected(state),
  lessons: getLessons(state),
  fetchState: fetchTutorState(state),
  paymentInfo: getPaymentInfo(state),
  reviews: getReviewsList(state),
  feedback: getFeedbackList(state),
  reviewsData: getReviewsData(state),
  analyticsData: getAnalyticsData(state),
  averageData: getAverages(state),
  paymentErrors: getPaymentErrors(state),
  lessonInfo: getLessonInfo(state),
  notes: getNotesList(state),
  tasks: get(state, 'router.location.state.tasks') || [],
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  fetchUserLesson: params => dispatch(fetchUserLesson(params)()),
  lessonSetInfo: params => dispatch(lessonSetInfo(params)),
  setReviewVisibility: params => dispatch(setReviewVisibility(params)()),
  fetchTutor: params => dispatch(fetchTutor(params)()),
  addNote: params => dispatch(addNote(params)()),
  removeNote: params => dispatch(removeNote(params)()),
  removeTutor: params => dispatch(removeTutor(params)()),
  clearSelectedTutor: () => dispatch(clearSelectedTutor()),
});

export default compose(
  withStyles(styles, { name: 'TutorCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(TutorCard);



// WEBPACK FOOTER //
// ./src/modules/tutors/cards/TutorCard/index.js